import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function UsageIndicator() {
  const { user } = useAuth();

  if (!user || user.plan !== 'free') return null;

  const LIMIT = 5;
  const today = new Date().toISOString().slice(0, 10);
  const isToday = user.last_search_date && user.last_search_date.slice(0, 10) === today;
  const count = isToday ? (user.daily_search_count || 0) : 0;
  const pct = Math.min((count / LIMIT) * 100, 100);

  let barColor = 'bg-[#171717]';
  if (count >= LIMIT) barColor = 'bg-red-500';
  else if (count >= 4) barColor = 'bg-amber-400';

  return (
    <div
      className="mt-3 bg-white rounded-lg px-4 py-3"
      style={{ boxShadow: 'rgba(0,0,0,0.08) 0px 0px 0px 1px' }}
    >
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-xs font-medium text-[#4d4d4d]">
          {count} / {LIMIT} searches today
        </span>
        {count >= LIMIT && (
          <span className="text-xs text-red-500 font-medium">Limit reached</span>
        )}
      </div>
      <div className="w-full bg-[#ebebeb] rounded-full h-1 overflow-hidden">
        <div
          className={`h-1 rounded-full transition-all duration-300 ${barColor}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      {count >= LIMIT && (
        <p className="mt-2 text-xs text-[#808080]">
          <Link to="/pricing" className="text-[#171717] font-medium hover:underline">
            Upgrade to Pro
          </Link>
          {' '}for unlimited searches
        </p>
      )}
    </div>
  );
}
